import { AnyAction } from 'redux';

import { Customer } from '../models/customer';
import {
    RECEIVE_CUSTOMER,
    REQUEST_CUSTOMERS,
    REQUEST_DEMAND_CUSTOMERS,
    RESET_CUSTOMER,
} from '../actions/customer-actions';

export interface CustomerReducerState {
    sortedByName: Customer[];
    single?: Customer;
    requesting: boolean;
    hasMore: boolean;
}

const initialCustomerReducerState: CustomerReducerState = {
    sortedByName: [],
    single: undefined,
    requesting: false,
    hasMore: false,
};

export const customerReducer = (
    state: CustomerReducerState = initialCustomerReducerState,
    action: AnyAction
): CustomerReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case REQUEST_DEMAND_CUSTOMERS:
        case REQUEST_CUSTOMERS: {
            return {
                ...state,
                requesting: true,
                hasMore: false,
            };
        }

        case RECEIVE_CUSTOMER: {
            return {
                ...state,
                single: rest['customer'],
                requesting: false,
            };
        }

        case RESET_CUSTOMER: {
            return {
                ...state,
                single: undefined,
            };
        }

        default: {
            return state;
        }
    }
};
